import 'angular:locale/data:it';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "it";
